import { gsap } from 'gsap';
export class NavigationManager {
    constructor(container, total) {
        this.container = container;
        this.total = total;
        this.onDotClickCallback = null;
        this.prevBtns = this.container.querySelectorAll('.nav-button.prev');
        this.nextBtns = this.container.querySelectorAll('.nav-button.next');
    }
    setup() {
        this.yearStartEl = this.container.querySelector('.year-start');
        this.yearEndEl = this.container.querySelector('.year-end');
        this.fractionEl = this.container.querySelector('.fraction');
        this.mobileFractionEl = this.container.querySelector('.mobile-fraction');
        this.mobileTitleEl = this.container.querySelector('.slider__mobile-title');
        this.mobileDotsContainer = this.container.querySelector('.mobile-dots');
        this.createMobileDots();
    }
    setButtonHandlers(onPrev, onNext) {
        this.prevBtns.forEach(btn => {
            btn.addEventListener('click', onPrev);
        });
        this.nextBtns.forEach(btn => {
            btn.addEventListener('click', onNext);
        });
    }
    setOnDotClick(callback) {
        this.onDotClickCallback = callback;
    }
    updateYears(periodString) {
        const [start, end] = periodString.split('-').map(year => year.trim());
        this.animateYear(this.yearStartEl, start);
        this.animateYear(this.yearEndEl, end);
    }
    animateYear(element, newValue) {
        const currentText = element.textContent || '0';
        const currentValue = parseInt(currentText);
        const targetValue = parseInt(newValue);
        if (isNaN(currentValue) || isNaN(targetValue)) {
            element.textContent = newValue;
            return;
        }
        if (currentValue === targetValue) {
            element.textContent = newValue;
            return;
        }
        console.log(`Анимация года: ${currentValue} → ${targetValue}`);
        gsap.to(element, {
            textContent: targetValue,
            duration: 1.2,
            ease: "power2.out",
            snap: { textContent: 1 },
            onUpdate: function () {
                const currentNum = Math.round(parseFloat(element.textContent || '0'));
                element.textContent = currentNum.toString();
                element.classList.add('counting');
            },
            onComplete: function () {
                element.classList.remove('counting');
                element.textContent = targetValue.toString();
            }
        });
    }
    updateFraction(current) {
        const formattedCurrent = (current + 1).toString().padStart(2, '0');
        const formattedTotal = this.total.toString().padStart(2, '0');
        const fraction = `${formattedCurrent}/${formattedTotal}`;
        this.fractionEl.textContent = fraction;
        this.mobileFractionEl.textContent = fraction;
    }
    updateMobileTitle(title) {
        this.mobileTitleEl.textContent = title;
    }
    createMobileDots() {
        this.mobileDotsContainer.innerHTML = '';
        for (let i = 0; i < this.total; i++) {
            const dot = document.createElement('div');
            dot.className = 'mobile-dot';
            if (i === 0)
                dot.classList.add('active');
            dot.addEventListener('click', () => {
                if (this.onDotClickCallback) {
                    this.onDotClickCallback(i);
                }
            });
            this.mobileDotsContainer.appendChild(dot);
        }
    }
    updateMobileDots(activeIndex) {
        const dots = this.mobileDotsContainer.querySelectorAll('.mobile-dot');
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === activeIndex);
        });
    }
    updateButtonsState(currentIndex) {
        const isPrevDisabled = currentIndex === 0;
        const isNextDisabled = currentIndex === this.total - 1;
        this.prevBtns.forEach(btn => {
            btn.disabled = isPrevDisabled;
            btn.style.opacity = isPrevDisabled ? '0.5' : '1';
            btn.style.cursor = isPrevDisabled ? 'not-allowed' : 'pointer';
        });
        this.nextBtns.forEach(btn => {
            btn.disabled = isNextDisabled;
            btn.style.opacity = isNextDisabled ? '0.5' : '1';
            btn.style.cursor = isNextDisabled ? 'not-allowed' : 'pointer';
        });
    }
}
